import React from "react";

export default function ContactInfo() {
  return (
    <section className="w-full z-10 mt-12 bg-white"> {/* Changed background to white */}
      <div className="flex flex-col items-center justify-center mb-20">
        <div className="border-t-2 border-gray-300 w-24 my-4"></div> {/* Changed border color to a lighter gray */}
        <div className="text-center">
          <h1 className="text-gray-900 text-[25px] md:text-[40px] font-bold tracking-widest">Contatti</h1> {/* Changed text color to dark gray */}
          <p className="text-gray-600 text-[16px] md:text-[20px] font-light mx-2 lg:mx-56 xl:mx-80"> {/* Changed text color to a darker gray */}
            Marrocco ART è a tua completa disposizione per qualsiasi domanda o chiarimento.  Contattaci per qualsiasi informazione o preventivo.
          </p>
        </div>
        <div className="border-b-2 border-gray-300 w-24 my-4"></div> {/* Changed border color to a lighter gray */}
        <div className="border-b-2 border-gray-300 w-16 -mt-2"></div> {/* Changed border color to a lighter gray */}
        <div className="border-b-2 border-gray-300 w-10 mt-2"></div> {/* Changed border color to a lighter gray */}
      </div>
    </section>
  );
}
